// src/components/AboutSection.js

import React from "react";
import { Box, Typography, Divider, Link as MuiLink } from "@material-ui/core";
import { Link } from "../util/router";
import useDashboardSectionStyles from "./useDashboardSectionStyles";

function AboutSection({ auth }) {
  const classes = useDashboardSectionStyles();

  return (
    <Box className={classes.aboutSection}>
      <Divider style={{ margin: "16px 0" }} />
      <Typography variant="body2" className={classes.aboutTypography}>
        Resume Revival helps you create professional, ATS-optimized resumes and
        cover letters tailored to your dream job.
      </Typography>

      <Typography variant="body2" component="div" style={{ marginTop: "8px" }}>
        {auth.user ? (
          <>
            Signed in as <strong>{auth.user.email}</strong> |
            <MuiLink
              component={Link}
              to="/settings/general"
              style={{ marginLeft: "4px" }}
            >
              Account Settings
            </MuiLink>
          </>
        ) : (
          <>
            <MuiLink component={Link} to="/auth">
              Sign in
            </MuiLink>{" "}
            to save your progress
          </>
        )}
      </Typography>
    </Box>
  );
}

export default AboutSection;
